<template>
  <div>
    <SiteHeader />
    <div class="page flex-col">
      <img class="image_1" referrerpolicy="no-referrer" :src="topStripImage" />
      <div class="box_1 flex-col">
        <div class="text-wrapper_1 flex-col" :style="heroBgStyle"><span class="text_8">{{ pageTitle }}</span></div>
        <div class="text-wrapper_2">
          <span class="text_9">
            <router-link to="/lanhu_shouye" style="color: inherit; text-decoration: none;">首页</router-link>
            &nbsp;&gt;&nbsp;
            <router-link to="/lanhu_jigouyulishi" style="color: inherit; text-decoration: none;">机构与历史</router-link>
            &nbsp;&gt;&nbsp;
            <router-link :to="sectionRoute" style="color: inherit; text-decoration: none;">{{ sectionLabel }}</router-link>
            &nbsp;&gt;&nbsp;
          </span>
          <span class="text_10">{{ pageTitle }}</span>
        </div>
        <div class="box_3 flex-col">
          <div class="text-wrapper_4 flex-col"><span class="text_19">{{ pageTitle }}</span></div>
          <div class="pdf-viewer">
            <div ref="pdfStage" class="pdf-stage" :style="pdfStageStyle">
              <div class="pdf-shell-offset" :style="pdfShellOffsetStyle">
                <div class="pdf-shell" :style="pdfShellStyle">
                  <div class="pdf-canvas" :style="pdfCanvasStyle">
                    <img :src="currentPage.src" :alt="`PDF 第 ${currentPage.pdfPage} 页内容`" class="page-visual" />
                    <span
                      v-for="(node, idx) in currentPageNodes"
                      :key="`${currentPage.pdfPage}-${idx}`"
                      class="pdf-text-node"
                      :style="node.style"
                    >
                      {{ node.text }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="pdf-meta">第 {{ currentPageIndex + 1 }} 页（共 {{ pages.length }} 页）</div>
            <div class="pdf-pager" role="tablist" :aria-label="pagerAriaLabel">
              <button
                v-for="(page, index) in pages"
                :key="page.pdfPage"
                type="button"
                :class="['pdf-pager__btn', { 'is-active': index === currentPageIndex }]"
                :aria-selected="(index === currentPageIndex).toString()"
                @click="currentPageIndex = index"
              >
                {{ index + 1 }}
              </button>
            </div>
          </div>
        </div>
        <SiteFooter :notch-width="1300" notch-left="calc((100vw - 1300px) / 2)" />
      </div>
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  name: 'PdfChapterTemplate',
  components: {
    SiteHeader,
    SiteFooter
  },
  props: {
    pageTitle: {
      type: String,
      required: true
    },
    sectionLabel: {
      type: String,
      required: true
    },
    sectionRoute: {
      type: [String, Object],
      default: '/lanhu_jigouyulishi'
    },
    pagerAriaLabel: {
      type: String,
      default: 'PDF页码切换'
    },
    pages: {
      type: Array,
      default: () => []
    },
    pageSize: {
      type: Object,
      default: () => ({
        width: 1322,
        height: 1003
      })
    },
    crop: {
      type: Object,
      default: () => ({
        left: 76,
        right: 76,
        top: 130,
        bottom: 98
      })
    },
    layoutXmlPath: {
      type: String,
      default: '/pdf/xuenihongzhao/layout.xml'
    },
    topStripImage: {
      type: String,
      required: true
    },
    heroBackgroundImage: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentPageIndex: 0,
      pageScale: 1,
      pageTextNodesMap: {},
      resizeObserver: null
    };
  },
  computed: {
    currentPage() {
      return this.pages[this.currentPageIndex] || this.pages[0] || { pdfPage: 1, src: '' };
    },
    currentPageNodes() {
      return this.pageTextNodesMap[this.currentPage.pdfPage] || [];
    },
    visibleHeight() {
      return Math.max(1, this.pageSize.height - this.crop.top - this.crop.bottom);
    },
    visibleWidth() {
      return Math.max(1, this.pageSize.width - this.crop.left - this.crop.right);
    },
    pdfStageStyle() {
      return {
        height: `${this.visibleHeight * this.pageScale}px`
      };
    },
    pdfShellOffsetStyle() {
      return {
        transform: `translate(${-this.crop.left * this.pageScale}px, ${-this.crop.top * this.pageScale}px)`
      };
    },
    pdfShellStyle() {
      return {
        height: `${this.pageSize.height * this.pageScale}px`
      };
    },
    pdfCanvasStyle() {
      return {
        width: `${this.pageSize.width}px`,
        height: `${this.pageSize.height}px`,
        transform: `scale(${this.pageScale})`
      };
    },
    heroBgStyle() {
      const rawUrl = this.heroBackgroundImage || '';
      if (!rawUrl) {
        return {};
      }
      const isAbsolute =
        /^(?:[a-z]+:)?\/\//i.test(rawUrl) ||
        rawUrl.startsWith('/') ||
        rawUrl.startsWith('data:') ||
        rawUrl.startsWith('blob:');
      const baseUrl = process.env.BASE_URL || '/';
      const normalizedBase = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
      const normalizedRaw = rawUrl.startsWith('./') ? rawUrl.slice(2) : rawUrl;
      const resolvedUrl = isAbsolute ? rawUrl : `${normalizedBase}${normalizedRaw}`;
      return {
        '--hero-bg-image': `url(${resolvedUrl})`
      };
    }
  },
  watch: {
    pages() {
      if (this.currentPageIndex >= this.pages.length) {
        this.currentPageIndex = 0;
      }
    },
    '$route.fullPath'() {
      this.$nextTick(() => {
        this.scrollToTop();
      });
    }
  },
  mounted() {
    this.scrollToTop();
    this.setupScaleSync();
    this.loadTextLayer();
    this.$nextTick(() => {
      this.scrollToTop();
    });
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updatePageScale);
    }
  },
  methods: {
    scrollToTop() {
      if (typeof window === 'undefined') {
        return;
      }
      window.scrollTo(0, 0);
      if (typeof document !== 'undefined') {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }
    },
    setupScaleSync() {
      this.$nextTick(() => {
        this.updatePageScale();
        if (typeof ResizeObserver !== 'undefined' && this.$refs.pdfStage) {
          this.resizeObserver = new ResizeObserver(() => this.updatePageScale());
          this.resizeObserver.observe(this.$refs.pdfStage);
        } else if (typeof window !== 'undefined') {
          window.addEventListener('resize', this.updatePageScale, { passive: true });
        }
      });
    },
    updatePageScale() {
      const stage = this.$refs.pdfStage;
      if (!stage) {
        return;
      }
      const width = stage.clientWidth || 1;
      this.pageScale = width / this.visibleWidth;
    },
    normalizeFontFamily(pdfFontName = '') {
      const base = pdfFontName.includes('+') ? pdfFontName.split('+')[1] : pdfFontName;
      const name = String(base).toLowerCase();
      if (name.includes('timesnewroman')) {
        return '"Times New Roman", Georgia, serif';
      }
      if (name.includes('stxingkai')) {
        return '"STXingkai", "Kaiti SC", "KaiTi", cursive';
      }
      if (name.includes('fz') || name.includes('adobesong') || name.includes('song')) {
        return '"Songti SC", "STSong", "Noto Serif SC", serif';
      }
      return '"PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif';
    },
    async loadTextLayer() {
      try {
        const response = await fetch(this.layoutXmlPath, { cache: 'no-cache' });
        if (!response.ok) {
          this.pageTextNodesMap = {};
          return;
        }
        const xmlText = await response.text();
        const xmlDoc = new DOMParser().parseFromString(xmlText, 'application/xml');
        const pages = Array.from(xmlDoc.querySelectorAll('page'));
        const map = {};

        pages.forEach((pageNode) => {
          const pageNumber = Number(pageNode.getAttribute('number'));
          const fontSpecs = {};
          Array.from(pageNode.querySelectorAll('fontspec')).forEach((fontNode) => {
            const id = fontNode.getAttribute('id');
            fontSpecs[id] = {
              size: Number(fontNode.getAttribute('size') || 14),
              family: this.normalizeFontFamily(fontNode.getAttribute('family') || ''),
              color: fontNode.getAttribute('color') || '#000000'
            };
          });

          const textNodes = Array.from(pageNode.querySelectorAll('text'))
            .map((textNode) => {
              const top = Number(textNode.getAttribute('top') || 0);
              const left = Number(textNode.getAttribute('left') || 0);
              const width = Number(textNode.getAttribute('width') || 0);
              const height = Number(textNode.getAttribute('height') || 0);
              const fontId = textNode.getAttribute('font');
              const font = fontSpecs[fontId] || {
                size: 14,
                family: '"Songti SC", "STSong", "Noto Serif SC", serif',
                color: '#000000'
              };
              if (top + height < this.crop.top || top > this.pageSize.height - this.crop.bottom) {
                return null;
              }
              const text = (textNode.textContent || '').replace(/\u00a0/g, ' ');
              const lineHeight = Math.max(Math.round(font.size * 1.15), height);
              return {
                text,
                style: {
                  top: `${top}px`,
                  left: `${left}px`,
                  width: width > 0 ? `${width}px` : 'auto',
                  height: `${height}px`,
                  fontSize: `${font.size}px`,
                  lineHeight: `${lineHeight}px`,
                  fontFamily: font.family,
                  color: font.color,
                  WebkitTextFillColor: font.color,
                  opacity: 0.015
                }
              };
            })
            .filter(Boolean);

          map[pageNumber] = textNodes;
        });

        this.pageTextNodesMap = map;
      } catch (error) {
        this.pageTextNodesMap = {};
      }
    }
  }
};
</script>

<style scoped>
.page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  padding: 0 0 82px;
}

.image_1 {
  width: 1300px;
  height: 39px;
  display: none;
}

.box_1 {
  background-color: #fff;
  position: relative;
  width: 100%;
  min-height: auto;
  margin: 0;
  box-sizing: border-box;
}

.text-wrapper_1 {
  position: relative;
  box-sizing: border-box;
  padding: 96px max(24px, calc((100% - 1300px) / 2)) 14px;
}

.text-wrapper_1::before {
  content: '';
  position: absolute;
  inset: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  background-image: var(--hero-bg-image);
  background-size: cover;
  background-position: center;
  box-shadow: inset 0 0 51px 0 rgba(0, 0, 0, 0.81);
  z-index: 0;
}

.text-wrapper_1 > * {
  position: relative;
  z-index: 1;
}

.text_8 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 48px;
  letter-spacing: 0.64px;
  font-family: SourceHanSerifCN-SemiBold;
  text-align: left;
  white-space: nowrap;
  line-height: 69px;
}

.text-wrapper_2 {
  width: min(1300px, 100%);
  min-height: 16px;
  overflow-wrap: break-word;
  font-size: 0;
  letter-spacing: 0.2133333384990692px;
  font-family: SourceHanSansCN-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 18px auto 0;
  padding: 0;
  box-sizing: border-box;
}

.text_9 {
  color: rgba(225, 96, 31, 1);
  font-size: 16px;
  font-family: SourceHanSansCN-Bold;
  font-weight: 700;
  line-height: 24px;
}

.text_10 {
  color: rgba(225, 96, 31, 1);
  font-size: 16px;
  font-family: SourceHanSansCN-Light;
  font-weight: 300;
  line-height: 24px;
}

.box_3 {
  background-color: rgba(255, 255, 255, 1);
  width: min(1300px, 100%);
  align-self: stretch;
  margin: 16px auto 0;
  padding: 15px 0 44px;
  box-sizing: border-box;
}

.text-wrapper_4 {
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.03);
  background-color: rgba(225, 96, 31, 1);
  width: 100%;
  margin-left: 0;
  padding: 7px 20px 8px;
  box-sizing: border-box;
}

.text_19 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 26px;
  letter-spacing: 0.3466666638851166px;
  font-family: SourceHanSerifCN-SemiBold;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
}

.pdf-viewer {
  width: 100%;
  margin: 18px 0 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pdf-stage {
  width: 100%;
  background: #fff;
  border: 0;
  box-shadow: none;
  overflow: hidden;
  overflow: clip;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.pdf-shell-offset {
  width: 100%;
  overflow: hidden;
  overflow: clip;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.pdf-shell {
  width: 100%;
  overflow: hidden;
  overflow: clip;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.pdf-canvas {
  position: relative;
  transform-origin: top left;
  overflow: hidden;
  overflow: clip;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.pdf-stage::-webkit-scrollbar,
.pdf-shell-offset::-webkit-scrollbar,
.pdf-shell::-webkit-scrollbar,
.pdf-canvas::-webkit-scrollbar {
  display: none;
}

.page-visual {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  pointer-events: none;
}

.pdf-text-node {
  position: absolute;
  display: inline-block;
  white-space: pre;
  margin: 0;
  pointer-events: auto;
  -webkit-user-select: text;
  user-select: text;
}

.pdf-text-node::selection {
  background: rgba(176, 19, 25, 0.2);
}

.pdf-meta {
  color: #7a685a;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  margin-left: 14px;
}

.pdf-pager {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: 14px;
}

.pdf-pager__btn {
  width: 36px;
  height: 36px;
  border: 1px solid #d8c7b6;
  background: #fff;
  color: #5d4e43;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s ease;
}

.pdf-pager__btn.is-active,
.pdf-pager__btn:hover {
  background: #e1601f;
  border-color: #e1601f;
  color: #fff;
}

.pdf-pager__btn:focus-visible {
  outline: 2px solid #9c1e23;
  outline-offset: 1px;
}

@media (max-width: 768px) {
  .page {
    overflow-x: hidden;
  }

  .box_1 {
    width: 100%;
    min-height: auto;
    padding: 0 16px 40px;
  }

  .text-wrapper_1 {
    width: 100%;
    margin: 0;
    padding: 90px 16px 24px;
    background-size: cover;
    background-position: center;
  }

  .text-wrapper_2 {
    width: 100%;
    margin: 16px 0 0;
    white-space: normal;
  }

  .text_8 {
    font-size: 28px;
    line-height: 36px;
    white-space: normal;
  }

  .box_3 {
    width: 100%;
    margin-top: 16px;
    padding: 0 0 24px;
  }

  .text-wrapper_4 {
    width: 100%;
    margin: 0;
    padding: 10px 16px;
  }

  .pdf-viewer {
    width: 100%;
    margin: 16px 0 0;
  }

  .pdf-meta {
    text-align: left;
    margin-left: 0;
  }

  .pdf-pager {
    overflow-x: visible;
    flex-wrap: wrap;
    padding-bottom: 4px;
    margin-left: 0;
  }

  .pdf-pager__btn {
    flex: 0 0 auto;
  }
}
</style>
